import * as BABYLON from '@babylonjs/core'
import { DisposerBag } from './disposerBag'

export interface HdriSkyOptions {
  /** Cubemap render size Babylon prefilters the panorama into — 512 is plenty for a backdrop. */
  size?: number
  /** Big enough to stay outside anything the camera can walk to. */
  domeDiameter?: number
  rotationY?: number
}

export interface HdriSkyResult {
  texture: BABYLON.HDRCubeTexture
  dome: BABYLON.Mesh
}

/**
 * The real-photo counterpart to `skyDome.ts`'s hand-painted gradient — loads
 * a real `.hdr` panorama (e.g. from Poly Haven), sets it as `scene.environmentTexture`
 * so PBR materials get real image-based lighting, and wraps it on a big
 * inward-facing sphere so it's also the visible backdrop. One real asset
 * doing the job the gradient dome + separate ambient lights used to split
 * between them.
 */
export function buildHdriSky(scene: BABYLON.Scene, bag: DisposerBag, url: string, opts: HdriSkyOptions = {}): HdriSkyResult {
  const { size = 512, domeDiameter = 600, rotationY = 0 } = opts

  const texture = bag.track(new BABYLON.HDRCubeTexture(url, scene, size, false, true, false, true))
  texture.rotationY = rotationY
  scene.environmentTexture = texture

  const mat = bag.track(new BABYLON.StandardMaterial('hdriSkyMat', scene))
  mat.reflectionTexture = texture
  mat.reflectionTexture.coordinatesMode = BABYLON.Texture.SKYBOX_MODE
  mat.diffuseColor = BABYLON.Color3.Black()
  mat.specularColor = BABYLON.Color3.Black()
  mat.backFaceCulling = false
  mat.disableLighting = true

  const dome = bag.track(BABYLON.MeshBuilder.CreateSphere('hdriSkyDome', { diameter: domeDiameter, segments: 12 }, scene))
  dome.material = mat
  dome.infiniteDistance = true
  dome.isPickable = false
  dome.applyFog = false

  return { texture, dome }
}
